import React, { Component } from 'react';
import './ViewablePasswordField.css';
import { ControlLabel } from 'react-bootstrap';

class ViewablePasswordField extends Component {
  constructor(props) {
    super(props);

    this.toggleVisibility = this.toggleVisibility.bind(this);

    this.state = {
      shown: false
    };
  }

  toggleVisibility() {
    this.setState({ shown: !this.state.shown });
  }

  render() {
    const { label, input, ...props } = this.props;
    return (
      <div className="input-container">
        <div className="form-group">
          <div className="flex-group">
            <ControlLabel>{label}</ControlLabel>
            <label
              className="control-label control-button"
              onClick={this.toggleVisibility}
            >
              {this.state.shown ? 'Hide' : 'Show'}
            </label>
          </div>
          <input
            className="form-control"
            {...input}
            {...props}
            type={this.state.shown ? 'text' : 'password'}
          />
        </div>
      </div>
    );
  }
}

export default ViewablePasswordField;



// WEBPACK FOOTER //
// ./src/components/ViewablePasswordField/index.js